import React, {useState, useEffect} from 'react';
import Menu from '../../components/sturtural/Menu';
import { helpHttp } from '../../helpers/helpHttp';
import { BASE_API } from '../../api/Globals';
import { Dialog } from 'primereact/dialog';
import { MegaMenu } from 'primereact/megamenu';
import { InputText } from 'primereact/inputtext';
import { Chip } from 'primereact/chip';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';

import FormValidation from './FormValidation';
import InfoCheck from './InfoCheck';
import { useNavigate } from 'react-router-dom';
import { storage } from '../../helpers/storage';

const Filtro = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(null);
    //const [getMunicipio, setMunicipio] = useState(null);
    const [getEscuelas, setEscuelas] = useState(null);
    const [getAlumnos, setAlumnos] = useState(null);

    const [selectButtonValue, setSelectButtonValue] = useState([]);
    const [selectButtonValueNivel, setSelectButtonValueNivel] = useState([]);
    const [selectButtonValueEstatus, setSelectButtonValueEstatus] = useState([]);

    const [menuNiveles, setMenuNiveles] = useState([]);

    const [getEscuelaId, setEscuelaid] = useState(null);
    const [formValidation, setFormValidation] = useState(false);
    const [dataForm, setDataForm] = useState(false);

    const [getTableEscuelas, setTableEscuelas] = useState(false);
    const [getTableAlumnos, setTableAlumnos] = useState(false);
    const [showAviso, setShowAviso] = useState({});

    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const [filters2, setFilters2] = useState(null);
    const [globalFilterValue2, setGlobalFilterValue2] = useState('');

    const perfil =  storage.get('perfilid');

    useEffect(() => {
        if(![1, 5, 9, 10, 11, 12].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);
    
    useEffect(() => {
        let obj = [];
        let objNivel = [
            {
                label: 'PREESCOLAR',
                icon: 'pi pi-fw pi-user-plus',
                code: 3,
                command: handleSelection_filtroNivel
            },
            {
                label: 'PRIMARIA',
                icon: 'pi pi-fw pi-user-edit',
                code: 1,
                command: handleSelection_filtroNivel
            },
            {
                label: 'SECUNDARIA',
                icon: 'pi pi-fw pi-user-edit',
                code: 2,
                command: handleSelection_filtroNivel
            }
        ];

        console.log("perfil " + perfil);

        if(perfil == 10) {
            obj = [{
                "code": 3,
                "name": "PREESCOLAR"
            }];

            objNivel = [
                {
                    label: 'PREESCOLAR',
                    icon: 'pi pi-fw pi-user-plus',
                    code: 3,
                    command: handleSelection_filtroNivel
                }
            ];
        } else if(perfil == 11){
            obj = [{
                "code": 1,
                "name": "PRIMARIA"
            }];

            objNivel = [
                {
                    label: 'PRIMARIA',
                    icon: 'pi pi-fw pi-user-edit',
                    code: 1,
                    command: handleSelection_filtroNivel
                }
            ];
        } else if(perfil == 12){
            obj = [{
                "code": 2,
                "name": "SECUNDARIA"
            }];

            objNivel = [
                {
                    label: 'SECUNDARIA',
                    icon: 'pi pi-fw pi-user-edit',
                    code: 2,
                    command: handleSelection_filtroNivel
                }
            ];
        }
        setMenuNiveles(objNivel);
        setSelectButtonValueNivel(obj)
    }, [perfil]);

    //let url = `${BASE_API}Entrega/postGpxObtenerMunicipios`;
    /*useEffect(() => {
        setLoading(true);
        helpHttp().get(url, {
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${window.localStorage.getItem('token')}`
            }
        }).then(res => {
            if(res.SUCCESS) {
                let oMunicipios = res.ITEMS;
                let arrMunicipios = oMunicipios.map(item => 
                    ({ 
                        label: item.name,
                        icon: 'pi pi-fw pi-map-marker',
                        code: item.code,
                        command: handleSelection_filtro
                    })
                );
                setMunicipio(arrMunicipios);
            } else {
                setMunicipio(null);
            }
            setLoading(false);
        });
    }, [url]);*/
    
    //let arrFiltro = [];
    const handleSelection_filtro = (e) => {
        let value = e.item;
        
        /*if(arrFiltro.filter(x => x.code === value.code).length === 0) {
            if(value) {
                arrFiltro.push({
                    code: value.code,
                    name: value.label
                });
                setSelectButtonValue(arrFiltro);
            }
        }*/

        if(selectButtonValue.filter(x => x.code === value.code).length === 0) {
            if(value) {
                let obj = {
                    code: value.code,
                    name: value.label
                };
                setSelectButtonValue([...selectButtonValue,obj]);
            }
        }
    }

    const handleSelection_filtroNivel = (e) => {
        let value = e.item;
        
        if(selectButtonValueNivel.filter(x => x.code === value.code).length === 0) {
            if(value) {
                let obj = {
                    code: value.code,
                    name: value.label
                };
                setSelectButtonValueNivel([...selectButtonValueNivel,obj]);
            }
        }
    }

    const handleSelection_filtroEstatus = (e) => {
        let value = e.item;
        if(value) {
            let obj = {
                code: value.code,
                name: value.label
            };
            setSelectButtonValueEstatus([obj]);
            setEscuelaid(null);
        }
    }

    useEffect(() => {
        initFilters1();
        initFilters2();
    }, [])

    useEffect(() => {
        if(selectButtonValue.length > 0 && selectButtonValueNivel.length > 0) {
            setLoading(true);
            helpHttp().post(`${BASE_API}Entrega/SpdRelEscuelasValid`, {
                body: {
                    IdMunicipio: selectButtonValue.map(item => item.code),
                    IdNivel: selectButtonValueNivel.map(item => item.code)
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if(res.SUCCESS) {
                    let oEscuerlas = res.ITEMS;
                    setEscuelas(oEscuerlas);
                    setTableAlumnos(false);
                    setTableEscuelas(true);
                } else {
                    setEscuelas(null);
                }
                setLoading(false);
            });
        } else {
            setEscuelas(null);
            setTableAlumnos(false);
            setTableEscuelas(false);
        }
    }, [selectButtonValue, selectButtonValueNivel]);

    useEffect(() => {
        if(getEscuelaId > 0 && selectButtonValueEstatus.length > 0) {
            //setLoading(true);
            helpHttp().post(`${BASE_API}Entrega/SpdRelAlumnoValid`, {
                body: {
                    IdEstatus: selectButtonValueEstatus.map(x => x.code).toString(),
                    IdEscuela: getEscuelaId
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                if(res.ITEMS.consultaAllumnoEntr.length > 0) {
                    let oAlumnos = res.ITEMS.consultaAllumnoEntr;
                    setAlumnos(oAlumnos);
                    setTableEscuelas(false);
                    setTableAlumnos(true);
                } else {
                    setAlumnos(null);
                    setShowAviso({show: true, message: "No se encontraron alumnos"});
                }
            // setLoading(false);
            });
        } else {
            setAlumnos(null);
            setTableEscuelas(true);
            setTableAlumnos(false);
        }
    }, [getEscuelaId, selectButtonValueEstatus]);

    const nestedMenuitems = [
        {
            label: 'Nivel',
            icon: 'pi pi-fw pi-table',
            items: [
                {
                    label: 'PREESCOLAR',
                    icon: 'pi pi-fw pi-user-plus',
                    code: 3,
                    command: handleSelection_filtroNivel
                },
                {
                    label: 'PRIMARIA',
                    icon: 'pi pi-fw pi-user-edit',
                    code: 1,
                    command: handleSelection_filtroNivel
                },
                {
                    label: 'SECUNDARIA',
                    icon: 'pi pi-fw pi-user-edit',
                    code: 2,
                    command: handleSelection_filtroNivel
                }
            ]
        },
        {
            label: 'Municipios',
            icon: 'pi pi-fw pi-shopping-cart',
            items: [
                {code:1,label:"ACONCHI", command: handleSelection_filtro},
                {code:2,label:"AGUA PRIETA", command: handleSelection_filtro},
                {code:3,label:"ALAMOS", command: handleSelection_filtro},
                {code:4,label:"ALTAR", command: handleSelection_filtro},
                {code:5,label:"ARIVECHI", command: handleSelection_filtro},
                {code:6,label:"ARIZPE", command: handleSelection_filtro},
                {code:7,label:"ATIL", command: handleSelection_filtro},
                {code:8,label:"BACADÉHUACHI", command: handleSelection_filtro},
                {code:9,label:"BACANORA", command: handleSelection_filtro},
                {code:10,label:"BACERAC", command: handleSelection_filtro},
                {code:11,label:"BACOACHI", command: handleSelection_filtro},
                {code:12,label:"BÁCUM", command: handleSelection_filtro},
                {code:13,label:"BANÁMICHI", command: handleSelection_filtro},
                {code:14,label:"BAVIÁCORA", command: handleSelection_filtro},
                {code:15,label:"BAVISPE", command: handleSelection_filtro},
                {code:16,label:"BENJAMÍN HILL", command: handleSelection_filtro},
                {code:17,label:"CABORCA", command: handleSelection_filtro},
                {code:18,label:"CAJEME", command: handleSelection_filtro},
                {code:19,label:"CANANEA", command: handleSelection_filtro},
                {code:20,label:"CARBÓ", command: handleSelection_filtro},
                {code:21,label:"COLORADA, LA", command: handleSelection_filtro},
                {code:22,label:"CUCURPE", command: handleSelection_filtro},
                {code:23,label:"CUMPAS", command: handleSelection_filtro},
                {code:24,label:"DIVISADEROS", command: handleSelection_filtro},
                {code:25,label:"EMPALME", command: handleSelection_filtro},
                {code:26,label:"ETCHOJOA", command: handleSelection_filtro},
                {code:27,label:"FRONTERAS", command: handleSelection_filtro},
                {code:28,label:"GRANADOS", command: handleSelection_filtro},
                {code:29,label:"GUAYMAS", command: handleSelection_filtro},
                {code:30,label:"HERMOSILLO", command: handleSelection_filtro},
                {code:31,label:"HUACHINERA", command: handleSelection_filtro},
                {code:32,label:"HUÁSABAS", command: handleSelection_filtro},
                {code:33,label:"HUATABAMPO", command: handleSelection_filtro},
                {code:34,label:"HUÉPAC", command: handleSelection_filtro},
                {code:35,label:"IMURIS", command: handleSelection_filtro},
                {code:36,label:"MAGDALENA", command: handleSelection_filtro},
                {code:37,label:"MAZATÁN", command: handleSelection_filtro},
                {code:38,label:"MOCTEZUMA", command: handleSelection_filtro},
                {code:39,label:"NACO", command: handleSelection_filtro},
                {code:40,label:"NÁCORI CHICO", command: handleSelection_filtro},
                {code:41,label:"NACOZARI DE GARCÍA", command: handleSelection_filtro},
                {code:42,label:"NAVOJOA", command: handleSelection_filtro},
                {code:43,label:"NOGALES", command: handleSelection_filtro},
                {code:44,label:"ONAVAS", command: handleSelection_filtro},
                {code:45,label:"OPODEPE", command: handleSelection_filtro},
                {code:46,label:"OQUITOA", command: handleSelection_filtro},
                {code:47,label:"PITIQUITO", command: handleSelection_filtro},
                {code:48,label:"PUERTO PEÑASCO", command: handleSelection_filtro},
                {code:49,label:"QUIRIEGO", command: handleSelection_filtro},
                {code:50,label:"RAYÓN", command: handleSelection_filtro},
                {code:51,label:"ROSARIO", command: handleSelection_filtro},
                {code:52,label:"SAHUARIPA", command: handleSelection_filtro},
                {code:53,label:"SAN FELIPE DE JESÚS", command: handleSelection_filtro},
                {code:54,label:"SAN JAVIER", command: handleSelection_filtro},
                {code:55,label:"SAN LUIS RÍO COLORADO", command: handleSelection_filtro},
                {code:56,label:"SAN MIGUEL DE HORCASITAS", command: handleSelection_filtro},
                {code:57,label:"SAN PEDRO DE LA CUEVA", command: handleSelection_filtro},
                {code:58,label:"SANTA ANA", command: handleSelection_filtro},
                {code:59,label:"SANTA CRUZ", command: handleSelection_filtro},
                {code:60,label:"SÁRIC", command: handleSelection_filtro},
                {code:61,label:"SOYOPA", command: handleSelection_filtro},
                {code:62,label:"SUAQUI GRANDE", command: handleSelection_filtro},
                {code:63,label:"TEPACHE", command: handleSelection_filtro},
                {code:64,label:"TRINCHERAS", command: handleSelection_filtro},
                {code:65,label:"TUBUTAMA", command: handleSelection_filtro},
                {code:66,label:"URES", command: handleSelection_filtro},
                {code:67,label:"VILLA HIDALGO", command: handleSelection_filtro},
                {code:68,label:"VILLA PESQUEIRA", command: handleSelection_filtro},
                {code:69,label:"YÉCORA", command: handleSelection_filtro},
                {code:70,label:"GENERAL PLUTARCO ELÍAS CALLES", command: handleSelection_filtro},
                {code:71,label:"BENITO JUÁREZ", command: handleSelection_filtro},
                {code:72,label:"SAN IGNACIO RÍO MUERTO", command: handleSelection_filtro}
            ]
        },
        {
            label: 'Status',
            icon: 'pi pi-fw pi-question-circle',
            items: [
                {
                    label: 'PENDIENTES',
                    icon: 'pi pi-fw pi-question',
                    code: 1,
                    command: handleSelection_filtroEstatus
                },
                {
                    label: 'APROBADOS',
                    icon: 'pi pi-fw pi-check',
                    code: 2,
                    command: handleSelection_filtroEstatus

                },
                {
                    label: 'RECHAZADOS',
                    icon: 'pi pi-fw pi-times',
                    code: 3,
                    command: handleSelection_filtroEstatus
                }
            ]
        }
    ];

    const megamenuItems = [
        {
            label: 'Nivel', icon: 'pi pi-fw pi-sitemap',
            items: [
                [
                    {
                        label: 'SELECCIONAR',
                        items: menuNiveles
                    }
                ]
            ]
        },
        {
            label: 'Municipios', icon: 'pi pi-fw pi-map-marker',
            items: [
                [
                    {
                        label: 'SELECCIONAR',
                        items: [
                            {code:1,label:"ACONCHI", command: handleSelection_filtro},
                            {code:2,label:"AGUA PRIETA", command: handleSelection_filtro},
                            {code:3,label:"ALAMOS", command: handleSelection_filtro},
                            {code:4,label:"ALTAR", command: handleSelection_filtro},
                            {code:5,label:"ARIVECHI", command: handleSelection_filtro},
                            {code:6,label:"ARIZPE", command: handleSelection_filtro},
                            {code:7,label:"ATIL", command: handleSelection_filtro},
                            {code:8,label:"BACADÉHUACHI", command: handleSelection_filtro},
                            {code:9,label:"BACANORA", command: handleSelection_filtro},
                            {code:10,label:"BACERAC", command: handleSelection_filtro},
                            {code:11,label:"BACOACHI", command: handleSelection_filtro},
                            {code:12,label:"BÁCUM", command: handleSelection_filtro},
                            {code:13,label:"BANÁMICHI", command: handleSelection_filtro},
                            {code:14,label:"BAVIÁCORA", command: handleSelection_filtro},
                            {code:15,label:"BAVISPE", command: handleSelection_filtro},
                            {code:16,label:"BENJAMÍN HILL", command: handleSelection_filtro},
                            {code:17,label:"CABORCA", command: handleSelection_filtro},
                            {code:18,label:"CAJEME", command: handleSelection_filtro}
                        ]
                    },
                ],
                [
                    {
                        label: 'SELECCIONAR',
                        items: [
                            {code:19,label:"CANANEA", command: handleSelection_filtro},
                            {code:20,label:"CARBÓ", command: handleSelection_filtro},
                            {code:21,label:"COLORADA, LA", command: handleSelection_filtro},
                            {code:22,label:"CUCURPE", command: handleSelection_filtro},
                            {code:23,label:"CUMPAS", command: handleSelection_filtro},
                            {code:24,label:"DIVISADEROS", command: handleSelection_filtro},
                            {code:25,label:"EMPALME", command: handleSelection_filtro},
                            {code:26,label:"ETCHOJOA", command: handleSelection_filtro},
                            {code:27,label:"FRONTERAS", command: handleSelection_filtro},
                            {code:28,label:"GRANADOS", command: handleSelection_filtro},
                            {code:29,label:"GUAYMAS", command: handleSelection_filtro},
                            {code:30,label:"HERMOSILLO", command: handleSelection_filtro},
                            {code:31,label:"HUACHINERA", command: handleSelection_filtro},
                            {code:32,label:"HUÁSABAS", command: handleSelection_filtro},
                            {code:33,label:"HUATABAMPO", command: handleSelection_filtro},
                            {code:34,label:"HUÉPAC", command: handleSelection_filtro},
                            {code:35,label:"IMURIS", command: handleSelection_filtro},
                            {code:36,label:"MAGDALENA", command: handleSelection_filtro}
                        ]
                    },
                ],
                [
                    {
                        label: 'SELECCIONAR',
                        items: [
                            {code:37,label:"MAZATÁN", command: handleSelection_filtro},
                            {code:38,label:"MOCTEZUMA", command: handleSelection_filtro},
                            {code:39,label:"NACO", command: handleSelection_filtro},
                            {code:40,label:"NÁCORI CHICO", command: handleSelection_filtro},
                            {code:41,label:"NACOZARI DE GARCÍA", command: handleSelection_filtro},
                            {code:42,label:"NAVOJOA", command: handleSelection_filtro},
                            {code:43,label:"NOGALES", command: handleSelection_filtro},
                            {code:44,label:"ONAVAS", command: handleSelection_filtro},
                            {code:45,label:"OPODEPE", command: handleSelection_filtro},
                            {code:46,label:"OQUITOA", command: handleSelection_filtro},
                            {code:47,label:"PITIQUITO", command: handleSelection_filtro},
                            {code:48,label:"PUERTO PEÑASCO", command: handleSelection_filtro},
                            {code:49,label:"QUIRIEGO", command: handleSelection_filtro},
                            {code:50,label:"RAYÓN", command: handleSelection_filtro},
                            {code:51,label:"ROSARIO", command: handleSelection_filtro},
                            {code:52,label:"SAHUARIPA", command: handleSelection_filtro},
                            {code:53,label:"SAN FELIPE DE JESÚS", command: handleSelection_filtro},
                            {code:54,label:"SAN JAVIER", command: handleSelection_filtro}
                        ]
                    },
                ],
                [
                    {
                        label: 'SELECCIONAR',
                        items: [
                            {code:55,label:"SAN LUIS RÍO COLORADO", command: handleSelection_filtro},
                            {code:56,label:"SAN MIGUEL DE HORCASITAS", command: handleSelection_filtro},
                            {code:57,label:"SAN PEDRO DE LA CUEVA", command: handleSelection_filtro},
                            {code:58,label:"SANTA ANA", command: handleSelection_filtro},
                            {code:59,label:"SANTA CRUZ", command: handleSelection_filtro},
                            {code:60,label:"SÁRIC", command: handleSelection_filtro},
                            {code:61,label:"SOYOPA", command: handleSelection_filtro},
                            {code:62,label:"SUAQUI GRANDE", command: handleSelection_filtro},
                            {code:63,label:"TEPACHE", command: handleSelection_filtro},
                            {code:64,label:"TRINCHERAS", command: handleSelection_filtro},
                            {code:65,label:"TUBUTAMA", command: handleSelection_filtro},
                            {code:66,label:"URES", command: handleSelection_filtro},
                            {code:67,label:"VILLA HIDALGO", command: handleSelection_filtro},
                            {code:68,label:"VILLA PESQUEIRA", command: handleSelection_filtro},
                            {code:69,label:"YÉCORA", command: handleSelection_filtro},
                            {code:70,label:"GENERAL PLUTARCO ELÍAS CALLES", command: handleSelection_filtro},
                            {code:71,label:"BENITO JUÁREZ", command: handleSelection_filtro},
                            {code:72,label:"SAN IGNACIO RÍO MUERTO", command: handleSelection_filtro}
                        ]
                    },
                ]
            ]
        },
        {
            label: 'Status', icon: 'pi pi-fw pi-tag',
            items: [
                [
                    {
                        label: 'SELECCIONAR',
                        items: [
                            {
                                label: 'PENDIENTES',
                                icon: 'pi pi-fw pi-question',
                                code: 1,
                                command: handleSelection_filtroEstatus
                            },
                            {
                                label: 'APROBADOS',
                                icon: 'pi pi-fw pi-check',
                                code: 2,
                                command: handleSelection_filtroEstatus
            
                            },
                            {
                                label: 'RECHAZADOS',
                                icon: 'pi pi-fw pi-times',
                                code: 3,
                                command: handleSelection_filtroEstatus
                            }
                        ]
                    }
                ]
            ]
        }
    ];

    const menubarEndTemplate = () => {
        /*return (
            <>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="text" placeholder="Search" />
                </span>
            </>
        );*/
    };

    const totalesBodyTemplate = (rowData) => {

        const pendientes = (rowData) => {
            let total = parseInt(rowData.TotalAlumnos);
            let aprobados = parseInt(rowData.TotalValidados);
            let rechazados = parseInt(rowData.TotalValidadosRechazados);
            let validados = (aprobados + rechazados);
            let pendinetes = (total - validados)

            return pendinetes;
        }

        return (
            <>
                <Tag className="m-1" severity="info" value={`Pendientes: ${pendientes(rowData)} / ${rowData.TotalAlumnos}`}></Tag><br />
                <Tag className="m-1" severity="warning" value={`Aprobados: ${rowData.TotalValidados}`/**/}></Tag><br />
                <Tag className="m-1" severity="success" value={`Rechazados: ${rowData.TotalValidadosRechazados}`/**/}></Tag>
            </>
        )
    }

    const showAlumnosByEscuela = (rowData) => {
        return <Button label="Alumnos" icon="pi pi-search" className="p-button-rounded mr-2 mb-2" onClick={() => selectionEscuelaId(rowData.IdEscuela)} />
    }

    const selectionEscuelaId = (IdEscuela) => {
        if(selectButtonValueEstatus.length === 0) {
            setShowAviso({show: true, message: `Debe seleccionar un Status en los filtros`});
        } else {
            setEscuelaid(IdEscuela);
        }
    }

    const validarBodyTemplate = (rowData) => {
        //return <Button type="button" icon="pi pi-times" onClick={() => handleFormValidationShow(rowData)} className="p-button-secondary">Validar</Button>;
        
        let code = parseInt(selectButtonValueEstatus[0]?.code);

        if(code === 1) {
            return <Button label="Validar" icon="pi pi-pencil" className="p-button-rounded mr-2 mb-2" onClick={() => handleFormValidationShow(rowData)} />
        } else if ([2, 3].includes(code)) {
            return <InfoCheck code={code} folio={rowData.Folio}/>
        } 
    }

    const handleFormValidationShow = (data) => {
        //console.log({data});
        setFormValidation(true);
        setDataForm(data);
    }

    const handleCerrarValidacion = (Folio) => {
        let ngetAlumnos = getAlumnos.filter(x => x.Folio !== Folio);
        setAlumnos(ngetAlumnos);
        setFormValidation(false);
    }

    const deleteButtonValueNivel = (code) => {
        let deletes = selectButtonValueNivel.filter(item => item.code !== code)
        setSelectButtonValueNivel(deletes);
    }

    const deleteButtonValueMunicipio = (code) => {
        let deletes = selectButtonValue.filter(item => item.code !== code)
        setSelectButtonValue(deletes);
    }

    const deleteButtonValueEstatus = (code) => {
        let deletes = selectButtonValueEstatus.filter(item => item.code !== code)
        setSelectButtonValueEstatus(deletes);
    }

    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'Codigo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'Escuela': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    const initFilters2 = () => {
        setFilters2({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'Folio': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'CURP': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'Nombre': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'ApellidoPaterno': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue2('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const clearFilter2 = () => {
        initFilters2();
    }

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;

        let _filters1 = { ...filters1 };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const renderHeader1 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar" className="p-button-outlined" onClick={clearFilter1} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="CT/ESCUELA" />
                </span>
            </div>
        )
    }

    const onGlobalFilterChange2 = (e) => {
        const value = e.target.value;

        let _filters2 = { ...filters2 };
        _filters2['global'].value = value;

        setFilters2(_filters2);
        setGlobalFilterValue2(value);
    }

    const renderHeader2 = () => {
        return (
            <div className="flex justify-content-between">
                <Button type="button" icon="pi pi-filter-slash" label="Limpiar" className="p-button-outlined" onClick={clearFilter2} />
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue2} onChange={onGlobalFilterChange2} placeholder="Buscar" />
                </span>
            </div>
        )
    }

    const header1 = renderHeader1();
    const header2 = renderHeader2();

    const handleShowTable_escuelas = () => {
        console.log("handleShowTable_escuelas");
        setTableAlumnos(false);
        setTableEscuelas(true);
    }

    return (
        <div className="grid">
            <Menu link='filtro' />

            <div className="col-12">
                <div className="card card-w-title">
                    <h5>Filtros</h5>
                    {/*<Menubar model={nestedMenuitems} end={menubarEndTemplate}></Menubar>*/}
                    <MegaMenu model={megamenuItems} />
                    <span className='p-3'>
                        {(selectButtonValueNivel.length > 0 ? selectButtonValueNivel.map(item => <Chip label={item.name} key={`nivel-${item.code}`} className="mr-2 mb-2" removable onRemove={() => deleteButtonValueNivel(item.code)} />) : "")}
                        {(selectButtonValue ? selectButtonValue.map(item => <Chip label={item.name} key={`municipio-${item.code}`} className="mr-2 mb-2" removable onRemove={() => deleteButtonValueMunicipio(item.code)} />) : "")}
                        {(selectButtonValueEstatus.length > 0 ? selectButtonValueEstatus.map(item => <Chip label={item.name} key={`estatus-${item.code}`} className="mr-2 mb-2" removable onRemove={() => deleteButtonValueEstatus(item.code)} />) : "")}
                    </span>
                </div>
            </div>

            {getTableEscuelas && 
            <div className="col-12">
                <div className="card">
                    <h5>Escuelas ({getEscuelas?.length})</h5>
                    <DataTable 
                        value={getEscuelas}  
                        className="p-datatable-gridlines" 
                        rows={10} 
                        showGridlines
                        paginator
                        filterDisplay="menu"
                        dataKey="Codigo" 
                        loading={loading} 
                        filters={filters1}
                        responsiveLayout="scroll"
                        emptyMessage="No se encontraron escuelas."
                        header={header1} >

                        <Column field="Codigo" header="CLAVE" />
                        <Column field="Escuela" header="ESCUELA" filter filterPlaceholder="Search by name" />
                        <Column field="Municipio" header="MUNICIPIO" />
                        <Column field="Nivel" header="NIVEL" />
                        <Column header="TOTALES" body={totalesBodyTemplate} style={{textAlign: "center", minWidth: '5rem'}} />
                        <Column header="..." body={showAlumnosByEscuela} style={{textAlign: "center", minWidth: '5rem'}} />
                    </DataTable>
                </div>
            </div>}

            {getTableAlumnos &&
            <div className="col-12">
                <div className="card">
                    <h5><Button icon="pi pi-arrow-left" className="p-button-rounded p-button-outlined" onClick={() => handleShowTable_escuelas()} /> Alumnos ({getAlumnos?.length})</h5>
                    <DataTable 
                        value={getAlumnos}  
                        className="p-datatable-gridlines" 
                        rows={20} 
                        showGridlines
                        paginator
                        filterDisplay="menu"
                        dataKey="IdAlumno" 
                        loading={loading} 
                        filters={filters2}
                        header={header2} 
                        responsiveLayout="scroll"
                        emptyMessage="No se encontraron alumnos.">

                        <Column field="Folio" header="FOLIO" />
                        <Column field="CURP" header="CURP" />
                        <Column field="Nombre" header="NOMBRE" />
                        <Column field="ApellidoPaterno" header="PRIMER APELLIDO" />
                        <Column field="ApellidoMaterno" header="SEGUNDO APELLIDO" />
                        <Column field="Grado" header="GRADO" />
                        <Column field="Grupo" header="GRUPO" />
                        <Column header="..." body={validarBodyTemplate} style={{textAlign: "center", minWidth: '5rem'}} />
                    </DataTable>
                </div>
            </div>}

            <Dialog header="Validar Entrega" visible={formValidation} style={{ width: '70vw' }} modal onHide={() => setFormValidation(false)}>
                <FormValidation dataForm={dataForm} handleCerrarValidacion={handleCerrarValidacion} />
            </Dialog>

            <Dialog header="Aviso" visible={showAviso.show} style={{ width: '30vw' }} modal onHide={() => setShowAviso(false)}>
                {showAviso.message}
            </Dialog>
        </div>
    );
}

export default Filtro;